/**
 * Single source of truth for where the session is kept.
 *
 * Two places need to read the access token — AuthService and the generated SDK's Configuration —
 * and they must agree on the storage, otherwise a session-only sign-in would still be picked up
 * from localStorage.
 */

export const TOKEN_KEY = 'crm_auth_token';
export const REFRESH_TOKEN_KEY = 'crm_auth_refresh_token';
export const PERSISTENT_KEY = 'crm_auth_persistent';

/** Key written by the previous client-side expiry mechanism, cleaned up on sign-out. */
export const LEGACY_EXPIRATION_KEY = 'crm_auth_token_expiration';

/**
 * localStorage survives a browser restart, sessionStorage does not. The "stay signed in" choice
 * made at sign-in decides which one holds the session; localStorage is the default so an existing
 * session keeps working after this change.
 */
export function sessionStorageFor(): Storage {
  return localStorage.getItem(PERSISTENT_KEY) === 'false'
    ? sessionStorage
    : localStorage;
}

export function readAccessToken(): string | null {
  return sessionStorageFor().getItem(TOKEN_KEY);
}

export function readRefreshToken(): string | null {
  return sessionStorageFor().getItem(REFRESH_TOKEN_KEY);
}
